export const GET_LAST_REGISTERED_WATCHER = 'GET_LAST_REGISTERED_WATCHER';
export const GET_LAST_REGISTERED_SUCCESS = 'GET_LAST_REGISTERED_SUCCESS';
export const GET_LAST_REGISTERED_FAILED = 'GET_LAST_REGISTERED_FAILED';
